import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Menu from './Menu/Menu';
import { firstAllowedPath, loadCustodyPages, pageKeyForPath } from '../services/CustodyPagesService';

function CustodyGate({ children }) {
    const location = useLocation();
    const isCustody = localStorage.getItem('isCustody') === 'true';
    const [access, setAccess] = useState(null);

    useEffect(() => {
        if (!isCustody) return undefined;
        let alive = true;
        loadCustodyPages()
            .then(next => { if (alive) setAccess(next); })
            .catch(() => { if (alive) setAccess({}); });
        return () => { alive = false; };
    }, [isCustody]);

    if (!isCustody || !access) return children;

    const key = pageKeyForPath(location.pathname);
    if (!key || access[key] !== false) return children;

    const next = firstAllowedPath(access);
    if (pageKeyForPath(next) !== key)
        return <Navigate to={next} replace />;

    return (
        <>
            <Menu />
            <main className="content">
                <div className="py-4">
                    <h1 className="h4">Página indisponível</h1>
                    <p className="text-muted">Esta área não está liberada para a sua conta.</p>
                </div>
            </main>
        </>
    );
}

export default CustodyGate;
